import { Box, styled } from "@mui/material";

export const HorzontalTimeLine = styled(Box)(() => ({
  width: "100%",
  height: "80px",
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "row",
  gap: "10px",
  alignItems: "center",
  marginBottom: "10px",
  paddingLeft: "20px",
  paddingRight: "20px",
})) as typeof Box;

export const HorzontalTimeLineContent = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  alignItems: "center",
  position: "relative",
})) as typeof Box;

export const HorzontalTimeLineContentLabel = styled(Box)(() => ({
  position: "absolute",
  top: "30px",
})) as typeof Box;
